import { UserAccountQueryEndpoint } from '@api/endpoints/UserAccountQueryEndpoint';

type Column = UserAccountQueryEndpoint.Query.UserAccountQueryColumn;

// Related columns sit together; within a group, the ones prod mostly leaves null come last.
const groupedColumns = [
  'id',
  'externalId',
  // Who they are and how to reach them
  'firstName',
  'lastName',
  'businessName',
  'email',
  'telephone',
  'address1',
  'address2',
  'city',
  'state',
  'postal',
  'telephoneSecondary',
  // What they belong to
  'userType',
  'retailerId',
  'rewardsAccountId',
  'walletAccountId',
  'defaultSalesperson',
  'accountGroupId',
  'accountGroupRole',
  'locationId',
  // Program membership
  'isActive',
  'excludeFromLoyaltyProgram',
  'isHistorical',
  'isAgronomyMember',
  'isEnergyMember',
  'isTest',
  // Notifications
  'sendNotifications',
  'textMsgOptedOut',
  // Signing in
  'permissions',
  'otpVerified',
  'emailVerified',
  'isProfileConfirmed',
  'isPhoneManuallySet',
  'requiresPasswordReset',
  'passwordAttemptsCount',
  'cognitoSyncedAt',
  'cognitoPasswordStale',
  'dashboardAccessToken',
  'dashboardAccessTime',
  // Row history
  'createdAt',
  'updatedAt',
  'deletedAt',
];

// Every prod row has these null, or the same value, so they go after anything unlisted.
const rarelySetColumns = [
  'countyId',
  'completedOrdersOverride',
  'isFeatured',
  'isNewUser',
  'tierHistoryBackfilled',
  'restrictedUseLicense',
  'restrictedUseLicenseExpirationDate',
  'taxExemptLicense',
  'taxExemptLicenseExpirationDate',
  'technologyLicense',
  'technologyLicenseExpirationDate',
  'otherLicenseName',
  'otherLicense',
  'otherLicenseExpirationDate',
];

const unlistedRank = groupedColumns.length;

const columnRank = (name: string): number => {
  const groupedIndex = groupedColumns.indexOf(name);
  if (groupedIndex >= 0) {
    return groupedIndex;
  }
  const rarelySetIndex = rarelySetColumns.indexOf(name);
  return rarelySetIndex >= 0 ? unlistedRank + 1 + rarelySetIndex : unlistedRank;
};

/** Unlisted columns, such as ones a migration adds, keep their table order before the rare ones. */
export const orderUserAccountColumns = (columns: Column[]): Column[] => (
  [...columns].sort((a, b) => columnRank(a.name) - columnRank(b.name))
);
